var map, center_pin_added = 0;
var GCSE_RESULTS_URL = '/' + jinjaVars.lang + '/us-cities/gcse-search/' + jinjaVars.short_name_url;

function renderOpenStreetMap() {
    mapboxgl.accessToken = jinjaVars.mapbox_token;
    var mapbox_satellite_layer = jinjaVars.mapbox_satellite_layer;

    map = new mapboxgl.Map({
        container: 'map',
        style: 'https://m.24timezones.com/styles/osm-bright-en/style.json',
        zoom: 10,
        center: [
            parseFloat(jinjaVars.longitude),
            parseFloat(jinjaVars.latitude)
        ],
        attributionControl: false,
        preserveDrawingBuffer: true
    });
    map.addControl(new mapboxgl.NavigationControl({showCompass: false}));
    map.addControl(new mapboxgl.FullscreenControl());

    var boundary_box = jinjaVars.boundary_box;
    var state_bbox = jinjaVars.state_bbox;
    var county_bbox = jinjaVars.county_bbox;

    if ('north' in boundary_box && 'west' in boundary_box && 'east' in boundary_box && 'south' in boundary_box) {
        map.fitBounds([
            [parseFloat(boundary_box['west']), parseFloat(boundary_box['south'])],
            [parseFloat(boundary_box['east']), parseFloat(boundary_box['north'])]
        ]);
    }

    map.addControl(new MapBoxGoogleCustomSearch({
        resultsUrl: GCSE_RESULTS_URL
    }), 'top-left');

    map.addControl(
        new MapBoxToPdfControl(
            jinjaVars.short_name + ', ' + jinjaVars.state_alpha,
            jinjaVars.save_to_pdf,
            jinjaVars.download_pdf
        ), 'top-left');

    map.addControl(new MapBoxDirectionsControl(
        jinjaVars.latitude + ', ' + jinjaVars.longitude,
        jinjaVars.directions
    ), 'top-left');

    var map_styles = [
        {
            id: 'street',
            title: jinjaVars.map,
            uri: 'https://m.24timezones.com/styles/osm-bright-' + jinjaVars.lang + '/style.json'
        },
        {
            id: 'satellite',
            title: jinjaVars.satellite,
            uri: 'https://m.24timezones.com/styles/hybrid-' + jinjaVars.lang + '/style.json'
        }
    ];
    var switcher_control = new MapBoxStyleSwitcherControl(map_styles, 'street');
    map.addControl(switcher_control);
    map.on('load', function () {
        var city_pin = new mapboxgl.Marker();
        city_pin.setLngLat([
            parseFloat(jinjaVars.longitude),
            parseFloat(jinjaVars.latitude)
        ]);

        document.getElementById("ctrl-fit-world-bounds").addEventListener("click", e => {
            map.setZoom(2);
            setTimeout(function () {
                city_pin.addTo(map);
            }, 300);
            e.stopPropagation();
            e.preventDefault();
        });

        if ('north' in state_bbox && 'west' in state_bbox && 'east' in state_bbox && 'south' in state_bbox) {
            document.getElementById("ctrl-fit-state-bounds").addEventListener("click", e => {
                map.fitBounds([
                    [parseFloat(state_bbox['west']), parseFloat(state_bbox['south'])],
                    [parseFloat(state_bbox['east']), parseFloat(state_bbox['north'])]
                ]);
                setTimeout(function () {
                    city_pin.addTo(map);
                }, 300);
                e.stopPropagation();
                e.preventDefault();
            });
        }
        if ('north' in boundary_box && 'west' in boundary_box && 'east' in boundary_box && 'south' in boundary_box) {
            document.getElementById("ctrl-fit-county-bounds").addEventListener("click", e => {
                map.fitBounds([
                    [parseFloat(county_bbox['west']), parseFloat(county_bbox['south'])],
                    [parseFloat(county_bbox['east']), parseFloat(county_bbox['north'])]
                ]);
                setTimeout(function () {
                    city_pin.addTo(map);
                }, 300);
                e.stopPropagation();
                e.preventDefault();
            });
        }
    });
}

function addCenterPinToMap() {
    if (center_pin_added) {
        return;
    }
    var popup = new mapboxgl.Popup({offset: 10, anchor: "top"});
    var center_pin = new mapboxgl.Marker({"color": "red"})
        .setLngLat(map.getCenter())
        .addTo(map);

    // create a HTML element for each feature
    var cs_marker_element = document.createElement('div');
    cs_marker_element.className = 'marker';
    var current_search_marker = new mapboxgl.Marker(cs_marker_element);
    current_search_marker.setPopup(popup);

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    function reverseGeoCoding(lat, lon, zoom) {
        var rc_zoom = 18;
        const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=${rc_zoom}&email=services@24timezones.com`
        const handleSuccess = data => {
            if ('display_name' in data) {
                popup.setHTML(data.display_name);

                current_search_marker.setLngLat([data.lon, data.lat]);
                current_search_marker.setPopup(popup);
                current_search_marker.addTo(map);
                current_search_marker.togglePopup();
            }
            if ('boundingbox' in data) {
                var bounding_box = data['boundingbox'];
                if (map.getLayer('search_result_bounds')) {
                    map.removeLayer('search_result_bounds');
                    map.removeSource('search_result_bounds');
                }

                map.addLayer({
                    id: 'search_result_bounds',
                    type: 'line',
                    source: {
                        type: 'geojson',
                        data: {
                            type: 'Feature',
                            geometry: {
                                type: 'Polygon',
                                coordinates: [[
                                    [bounding_box[2], bounding_box[0]],
                                    [bounding_box[3], bounding_box[0]],
                                    [bounding_box[3], bounding_box[1]],
                                    [bounding_box[2], bounding_box[1]],
                                    [bounding_box[2], bounding_box[0]]
                                ]]
                            }
                        }
                    },
                    paint: {
                        'line-color': '#088'
                    }
                });
            }
        };

        httpGet(url, handleSuccess);
    }

    var on_moved_marker = debounce(reverseGeoCoding, 500);
    map.on('move', function (e) {
        center_pin.setLngLat(map.getCenter());
    });
    map.on('drag', function (e) {
        var map_center = map.getCenter();
        center_pin.setLngLat(map_center);
        on_moved_marker(map_center.lat, map_center.lng, map.getZoom());
    });

    center_pin_added = 1;
}

if (mapboxgl.supported()) {
    renderOpenStreetMap();
} else {
    mapElement.style.backgroundImage = 'url(https://m.24timezones.com/styles/osm-bright-' + mapBackgroundLang + '/static/' + jinjaVars.longitude + jinjaVars.latitude + ',10/800x600.png)';
    mapElement.style.backgroundRepeat = 'no-repeat';
    mapElement.appendChild(document.getElementById("gmap-search-box"));

    const gcseSearchbox = document.createElement("gcse:searchbox-only");
    gcseSearchbox.adchannel = "5938292357";
    gcseSearchbox.lr = 'lang_' + jinjaVars.lang;
    gcseSearchbox.webSearchQueryAddition = jinjaVars.short_name;

    (function () {
        const cx = 'partner-pub-6183744382086490:4052689605';
        const gcse = document.createElement('script');
        gcse.type = 'text/javascript';
        gcse.async = true;
        gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
        const s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(gcse, s);
    })();
}

const mapSearchLinks = document.querySelectorAll(".map-search-link");

for (const link of mapSearchLinks) {
    link.addEventListener("click", e => {
        const query = link.getAttribute("data-query");
        if (typeof dataLayer !== "undefined") dataLayer.push({event: "map-search", q: query});
        window.location.href = `${GCSE_RESULTS_URL}?q=${encodeURIComponent(query)}`;
        e.stopPropagation();
        e.preventDefault();
    });
}
